module.exports = "data:application/x-font-ttf;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI0NmU0OGNlMDYyODgzNWY2OGE3MzY5ZDAyNTRlNDI4My50dGYiOw=="


//////////////////
// WEBPACK FOOTER
// ../~/materialize-css/fonts/roboto/Roboto-Light.ttf
// module id = 443
// module chunks = 0